export function formatDate(dateString, locale = 'uk') {
  if (!dateString) return '';
  const date = new Date(dateString);
  if (isNaN(date.getTime())) return '';
  const options = {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  };

  // Define locales for Intl.DateTimeFormat
  const localeMap = {
    uk: 'uk-UA',
    en: 'en-US',
  };

  return new Intl.DateTimeFormat(localeMap[locale] || 'uk-UA', options).format(
    date,
  );
}

export function formatDateRange(duration, locale = 'uk') {
  if (!duration || typeof duration !== 'object') {
    return { startDate: '', endDate: '' };
  }

  const startDate = duration.start ? formatDate(duration.start, locale) : '';
  const endDate = duration.end ? formatDate(duration.end, locale) : '';

  return {
    startDate,
    endDate,
  };
}
